import { Component, OnInit } from '@angular/core';
import { ParamMap } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { SessionState } from '@platform-frontend/account';
import { ProductState } from '@platform-frontend/checkout';
import { Product } from '@platform-frontend/marketplace';
import { CloseWindow, SimpleRouterState } from '@platform-frontend/util';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'yat-academic-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {
  constructor(private store: Store) {}

  @Select(SimpleRouterState.queryParamMap)
  queryParams$: Observable<ParamMap>;

  @Select(SessionState.email)
  sessionEmail$: Observable<string | null>;

  @Select(ProductState.product)
  product$: Observable<Product | null>;

  @Select(ProductState.productName)
  productName$: Observable<string | null>;

  email$: Observable<string | null>;

  ngOnInit(): void {
    this.email$ = this.queryParams$.pipe(
      map(params => params.get('email')),
      switchMap(email => (email === null ? this.sessionEmail$ : of(email)))
    );
  }

  getDownloadOverviewPath(): Observable<string> {
    return this.product$.pipe(map(product => product?.productPaths.find(path => path.type === 'DOWNLOAD_PAGE')?.url ?? ''));
  }

  close(): void {
    this.store.dispatch(new CloseWindow());
  }
}
